import React from 'react';
import { Popup } from 'devextreme-react/popup';
import { connect } from "react-redux";
import * as cactivityScheduleCrud from '../../../../crud/activitySchedule.crud';
import DataGrid, { Scrolling, ColumnFixing, HeaderFilter, FilterPanel, Export } from 'devextreme-react/data-grid';
import { withRouter } from '../../../../shared/hoc/withRouter';
import { GetDatePriceChangeStates } from '../../../../shared/lookup';
import { injectIntl } from "react-intl";
import { withSnackbar } from 'notistack';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';

class ContractSecondaryDateDetails extends React.Component {
  constructor(props) {
    super(props);
    this.changeStates = GetDatePriceChangeStates(props.intl);
    this.gridRef = React.createRef();
    this.state = {
      secondaryDateDetails: null,
    }
  }

  componentDidMount() {
    this.fetchSecondaryDateChanges();
  }
  componentDidUpdate() {
    this.fetchSecondaryDateChanges();
  }
  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
  fetchSecondaryDateChanges = async () => {
    if (this.props.secondaryDate && !this.state.secondaryDateDetails) {
      if (this.gridRef?.current?.instance) {
        this.gridRef.current.instance().beginCustomLoading();
      }

      const response = await cactivityScheduleCrud.fetchSecondaryDateChanges(this.props.secondaryDate.activityscheduleid);
      this.setState({ secondaryDateDetails: response.data }, () => {
        if (this.gridRef?.current?.instance) {
          this.gridRef.current.instance().option("filterValue", [["state", "=", 3], "or", ["state", "=", 5], "or", ["state", "=", 6], "or", ["state", "=", 7]]);
          this.gridRef.current.instance().endCustomLoading();
        }
        this.timer = setTimeout(() => {
          if (this.gridRef?.current?.instance) {
            this.gridRef.current.instance().repaint();
          }
        }, 300);
      })
    }
  }
  onClose = () => {
    this.setState({ secondaryDateDetails: null }, this.props.onClose())
  }
  onLinkClicked = (e) => {
    let { workflowsQA } = this.props.contractTemplate;
    const clonedItem = { ...e.row.data };
    if (workflowsQA[clonedItem.relatedworkflowid]) {
      let navigationPath = workflowsQA[clonedItem.relatedworkflowid].paths.basePath;
      if (clonedItem.relatedparentrecordid && clonedItem.relatedmodel === "Quotation") {
        navigationPath = navigationPath + clonedItem.relatedparentrecordid + "/quote/" + clonedItem.relatedrecordid;
      }
      else {
        navigationPath = navigationPath + clonedItem.relatedrecordid;
      }
      this.props.navigate(navigationPath);
    }
    else {
      this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.WARNING.RELATED_NOTICE_NOT_FOUND' }), { variant: 'warning', });
    }
  }

  onExporting = (e) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(this.props.intl.formatMessage({ id: 'REGISTER.EXPORTS.MAIN_SHEET' }));

    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
    }).then(() => {  // Using arrow function here
      workbook.xlsx.writeBuffer()
        .then((buffer) => {  // Using arrow function here to preserve 'this'
          saveAs(
            new Blob([buffer], { type: 'application/octet-stream' }),
            this.props.intl.formatMessage({ id: 'REGISTER.EXPORTS.CONTRACT_SECONDARY_DATES_CHANGE_LOGS' }) + '.xlsx'
          );
        });
    });
  };

  render() {
    return (
      <Popup
        visible={!!this.props.secondaryDate}
        onHiding={this.onClose}
        dragEnabled={true}
        hideOnOutsideClick={true}
        showTitle={true}
        title={this.props.intl.formatMessage({ id: 'GENERAL.CHANGE_LOG.TITLE' }, { ITEM_NAME: this.props.secondaryDate?.name })}
        width='80vw'
        height='82vh'
      >
        <DataGrid
          ref={this.gridRef}
          width='100%'
          height='100%'
          dataSource={this.state.secondaryDateDetails}
          keyExpr="secondaryactivityid"
          hoverStateEnabled={false}
          rowAlternationEnabled={true}
          noDataText={'No Data'}
          showBorders={true}
          showColumnLines={true}
          showRowLines={true}
          remoteOperations={false}
          onExporting={this.onExporting}
          columns={[
            {
              caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.STATE' }),
              dataField: "state",
              dataType: "string",
              lookup: {
                dataSource: this.changeStates,
                valueExpr: "value",
                displayExpr: "display"
              }
            },
            {
              caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.APPLIED_DATE' }),
              dataField: "applieddate",
              dataType: "date",
              format: 'dd/MM/yyyy'
            },
            {
              caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CHANGED_BY' }),
              dataType: "string",
              dataField: "appliedby",
            },
            {
              caption: this.props.intl.formatMessage({ id: 'SECONDARYDATE.FORMS.OLD_DATE' }),
              dataField: "olddate",
              dataType: "date",
              format: 'dd/MM/yyyy'
            },
            {
              caption: this.props.intl.formatMessage({ id: 'SECONDARYDATE.FORMS.DAYS_CHANGE' }),
              dataField: 'daychange'
            },
            {
              caption: this.props.intl.formatMessage({ id: 'SECONDARYDATE.FORMS.NEW_DATE' }),
              dataField: "newdate",
              dataType: "date",
              format: 'dd/MM/yyyy'
            },
            {
              caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.RELATED_REFERENCE_ID' }),
              dataType: "string",
              dataField: "relatedreferenceid",
            },
            {
              type: "buttons",
              buttons: [{ hint: 'Go to document', icon: 'link', onClick: this.onLinkClicked }]
            }
          ]}
        >

          <HeaderFilter visible={true} />
          <FilterPanel visible={true} />
          <ColumnFixing enabled={true} />
          <Export enabled={true} fileName={this.props.intl.formatMessage({ id: 'REGISTER.EXPORTS.CONTRACT_SECONDARY_DATES_CHANGE_LOGS' })} />
          <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />
        </DataGrid>

      </Popup>
    );
  }
}

const mapStateToProps = store => ({
  contractTemplate: store.contract.template,
  lang: store.i18n.lang
});

export default injectIntl(withSnackbar(withRouter(connect(mapStateToProps)(ContractSecondaryDateDetails))));